import axios from 'axios'
import qs from 'qs'

export const leapsCategoryService = ({
  getLeapsCategoryList (token) {
    return axios.get('/api/leaps/Category', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsCategory (token, leapsCategoryObj) {
    var stringifiedObj = qs.stringify(leapsCategoryObj)
    return axios.post('/api/leaps/Category', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsCategory (token, leapsCategoryObj) {
    var stringifiedObj = qs.stringify(leapsCategoryObj)
    return axios.put('/api/leaps/Category', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsCategory (token, challengeCategoryId) {
    return axios.delete('/api/leaps/Category?CategoryID=' + challengeCategoryId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-category-service.js